export const V1_CLEAR_SEAT_TRADE_NOTIFICATIONS =
  'V1_CLEAR_SEAT_TRADE_NOTIFICATIONS'

export default () => {
  return {
    type: V1_CLEAR_SEAT_TRADE_NOTIFICATIONS,
  }
}
